module.exports = __webpack_public_path__ + "49e91c9a8a105a1fd6c6eb0c6117a978.svg";